module.exports = __webpack_public_path__ + "static/img/im6.48ce0129.png";